import { styled, Checkbox } from "@mui/material";
import { GroupMessageStyled } from "../styles.js";
import FormControlLabel from "../../../vendor/@mui/material/FormControlLabel/FormControlLabel.js";
const CheckboxStyled = styled(Checkbox)(({ theme }) => ({
  padding: "0",
  marginRight: "12px",
  color: theme.palette.secondary[900],
  height: "20px",
  position: "relative",
  borderRadius: "unset",
  "&.MuiCheckbox-indeterminate": {
    color: theme.palette.secondary[900]
  },
  "&.Mui-checked": {
    color: theme.palette.secondary[900]
  },
  "&:hover": {
    backgroundColor: theme.palette.secondary[200],
    color: theme.palette.secondary[800],
    "&.Mui-checked": {
      color: theme.palette.secondary[800],
      backgroundColor: theme.palette.white.main
    }
  },
  "&:active": {
    backgroundColor: theme.palette.secondary[200],
    color: theme.palette.secondary[1e3],
    "&.Mui-checked": {
      color: theme.palette.secondary[1e3],
      backgroundColor: theme.palette.white.main
    }
  },
  "&.Mui-disabled": {
    color: theme.palette.grey[400]
  },
  "&.MuiCheckbox-colorError": {
    color: theme.palette.error.main,
    "&:hover": {
      color: theme.palette.error.main,
      "&.Mui-checked": {
        color: theme.palette.error.main
      }
    }
  }
})), StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: "0",
  alignItems: "start",
  ".MuiFormControlLabel-label": {
    color: theme.palette.grey[800]
  },
  "&.Mui-disabled": {
    color: theme.palette.grey[400]
  }
})), CheckboxMessageStyled = GroupMessageStyled;
export {
  CheckboxMessageStyled,
  CheckboxStyled,
  StyledFormControlLabel
};
//# sourceMappingURL=styles.js.map
